import { useForm } from "react-hook-form";
import { IUserDto } from "Apis/Models/IUserDto";
import ControlledInput from "Components/Input";
import { useTranslation } from "react-i18next";
import Button from "Components/Button";
import {useMutateApiUser} from "Apis/UsersApi";
import Space from "Components/Space";
import FlexRow from "Components/FlexRow";
import { useEffect } from "react";

interface IProps {
    user?: IUserDto;
    onSubmit?: (data: IUserDto) => void;
}
const ApiUserForm = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { control, handleSubmit, reset } = useForm<IUserDto>()
    const { mutateAsync, isLoading } = useMutateApiUser();
    
    useEffect(() => {
        if (props.user) {
            reset(props.user);
        }
    }, [reset, props.user])
    
    const onSubmit = async(data: IUserDto) => {
        await mutateAsync(data);
        
        if (props.onSubmit) {
            props.onSubmit(data);
        }
        
        reset();
    }
    
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Space direction={"vertical"} size={"large"}>
                <ControlledInput rules={{required: true}} name={"name"} control={control} placeholder={t('name')} />
                
                <FlexRow justify={"end"}>
                    <Button buttonType={"submit"} type={"primary"} text={t('save')} loading={isLoading} />
                </FlexRow>
            </Space>
        </form>
    )
}

export default ApiUserForm
